import Booking, { auth, authWithPassword, hasCanceledFlag, } from "../../../shared/functions/booking";
import { loginWithTwoFactorCode, requestTwoFactorLoginCode, } from "../../../shared/functions/booking";
import { getBlockedUntilTime, logError } from "../../../shared/functions/misc";
import { text, isValidInput } from "@phoenixreisen/form";
import { saveLoginToLastLogins } from "../shared/functions";
import Modal from "@phoenixreisen/mithrils/src/modal";
import isNumeric from "validator/lib/isNumeric";
import { Usertypes } from "../shared/usertypes";
import isEmpty from "validator/lib/isEmpty";
import Context from "../shared/context";
import { jwtDecode } from "jwt-decode";
import User from "@phoenixreisen/user";
import Config from "../../../config";
import Stream from "mithril/stream";
import striptags from "striptags";
import m from "mithril";
import { setHasTokenRenewedAt } from "@phoenixreisen/frontend-lib";
async function requestTwoFactorCode(state, username, jwt) {
    try {
        state.submitting = true;
        const result = await requestTwoFactorLoginCode(username, jwt);
        state.twoAuthResponse = result;
    }
    catch (e) {
        const error = e;
        state.error = error;
        logError(error);
    }
    finally {
        state.submitting = false;
        m.redraw();
    }
}
const submit = async (state, attrs, e) => {
    e?.preventDefault?.();
    const { urls } = Config;
    const { first, second, pwd } = state.fields;
    const { twoAuthFields, twoAuthResponse } = state;
    const { username, jwt, twoFactorCode } = twoAuthFields;
    state.error = null;
    if (state.pwdprotected) {
        pwd.validate(pwd.value());
    }
    first.validate(first.value());
    second.validate(second.value());
    if (first.complaint || second.complaint || pwd.complaint) {
        return;
    }
    else if (twoAuthResponse && !isValidInput(twoAuthFields)) {
        return;
    }
    try {
        state.submitting = true;
        if (twoAuthResponse) {
            await loginWithTwoFactorCode(username.value(), twoFactorCode.value(), jwt.value());
        }
        else {
            if (pwd.value())
                await authWithPassword(first.value(), second.value(), pwd.value());
            else
                await auth(first.value(), second.value());
        }
        setHasTokenRenewedAt();
        User.load();
        if (User.isPhx()) {
            return !jwtDecode(User.jwt).email
                ? m.route.set("/mitarbeiter/kontakt")
                : (location.href = urls.TAKE_OVER);
        }
        else if (User.isServiceProvider()) {
            return (location.href = urls.SPA_CMS);
        }
        else if (User.getType() === "Mitarbeiter") {
            throw { status: "missing-role" };
        }
        else {
            const rechnr = Booking.getBookingNr(User);
            const booking = await Booking.getBookingByNr(rechnr, true, "XL");
            if (booking && (state.saveLogin || attrs.isLastLogin)) {
                saveLoginToLastLogins(booking);
            }
            if (booking && booking["buchung/umleitung-url"]?.length) {
                return (location.href = Booking.data["buchung/umleitung-url"]);
            }
            else if (booking && hasCanceledFlag(booking)) {
                return (location.href = urls.CANCELED);
            }
            else if (!User.isPasswordAuthenticated()) {
                return (location.href = urls.PASSWORD_SET);
            }
            else {
                return (location.href = urls.OVERVIEW);
            }
        }
    }
    catch (e) {
        const error = e;
        if (error) {
            if (error.message === "unauthorized") {
                state.pwdprotected = true;
            }
            else if (error.status && error.status === "two-factor-auth-required") {
                if (!error.username) {
                    logError(Error(`"username" für Zwei-Faktor-Auth nicht gesetzt bei ${first.value()}`));
                    location.href = urls.API_ERROR;
                }
                else {
                    jwt.value(error.jwt);
                    username.value(error.username);
                    await requestTwoFactorCode(state, error.username, error.jwt);
                }
            }
            else if (error["status"]) {
                state.error = error;
            }
            else if (error["userfriendly-message"]) {
                state.error = error;
            }
        }
        else {
            logError(e);
            location.href = urls.API_ERROR;
        }
        state.submitting = false;
        m.redraw();
    }
};
export const View = {
    oninit({ state, attrs }) {
        const isRequired = true;
        state.error = null;
        state.saveLogin = false;
        state.submitting = false;
        state.showPwHelp = false;
        state.pwdprotected = false;
        state._prevPwdProtected = false;
        state.showpassword = false;
        state.user = Usertypes.CUSTOMER;
        state.fields = {
            first: {
                required: true,
                complaint: false,
                value: Stream(""),
                validate: (input) => {
                    const { first } = state.fields;
                    first.complaint = isEmpty(input);
                    state.error = null;
                    if (!isEmpty(input)) {
                        state.user = isNumeric(input)
                            ? Usertypes.CUSTOMER
                            : Usertypes.PHOENIX;
                    }
                    first.value(input);
                },
            },
            second: {
                required: true,
                complaint: false,
                value: Stream(""),
                validate: (input) => {
                    const { second } = state.fields;
                    state.error = null;
                    second.complaint = isEmpty(input);
                    second.value(input);
                },
            },
            pwd: text(isRequired, () => {
                state.error = null;
            }),
        };
        state.twoAuthFields = {
            jwt: text(isRequired),
            username: text(isRequired),
            twoFactorCode: text(isRequired),
        };
        if (attrs.prefilled) {
            const name = m.route.param("name");
            const rechnr = m.route.param("rechnr");
            if (rechnr && name) {
                state.fields.first.validate(rechnr);
                state.fields.second.validate(name);
            }
            else {
                location.href = Config.urls.FE_ERROR;
            }
        }
    },
    oncreate({ attrs }) {
        if (attrs.prefilled && attrs.triggerSubmit) {
            const btn = document.querySelector("#normal-login");
            btn.click();
        }
    },
    onupdate({ state }) {
        if (!state._prevPwdProtected && state.pwdprotected) {
            const pwField = document.querySelector('input[name="password"]');
            if (pwField)
                pwField.focus();
        }
        state._prevPwdProtected = state.pwdprotected;
    },
    view({ state, attrs }) {
        const { urls, html } = Config;
        const { error, submitting } = state;
        const { first, second, pwd } = state.fields;
        const { twoFactorCode } = state.twoAuthFields;
        const { webtexte, storageIsNotAvailable } = Context;
        const { pwdprotected, showpassword, twoAuthResponse } = state;
        try {
            const isCustomer = state.user === Usertypes.CUSTOMER;
            const isGuestUser = attrs.prefilled && attrs.showAdvice;
            const blockedUntil = getBlockedUntilTime(error?.["blocked-until"] ?? null);
            const noInputPossible = submitting || storageIsNotAvailable || !User.online;
            return (m("form", { class: "form login-form jackInTheBox animated fast", onsubmit: (e) => submit(state, attrs, e), "aria-live": "assertive" },
                !User.online && (m("p", { class: "alert alert--danger alert--icon" },
                    m("i", { class: "fas fa-exclamation-triangle" }),
                    "Sie haben zurzeit keine Verbindung zum Internet.")),
                User.online &&
                    !storageIsNotAvailable &&
                    !!webtexte?.["login__infosatz"] && (m("p", { class: "alert alert--info alert--icon mb3" },
                    m("i", { class: "fas fa-info-circle ml1 mr2" }),
                    m("small", null, m.trust(striptags(webtexte["login__infosatz"], html.allowed))))),
                error?.["userfriendly-message"] && (m("div", { class: "alert alert--danger alert--icon mb3" },
                    m("i", { class: "fas fa-exclamation-triangle" }),
                    error["userfriendly-message"])),
                error?.["status"] === "wrong-username-password" && (m("div", { class: "pulse animated" },
                    m("p", { class: "alert alert--danger alert--icon mb3" },
                        m("i", { class: "fas fa-exclamation-triangle" }),
                        "Falsche Zugangsdaten. Bitte pr\u00FCfen Sie Ihre Eingaben."))),
                error?.["status"] === "unknown-username" && (m("div", { class: "pulse animated" },
                    m("p", { class: "alert alert--danger alert--icon mb3" },
                        m("i", { class: "fas fa-exclamation-triangle" }),
                        "Diese Buchung ist uns unbekannt. Bitte pr\u00FCfen Sie Ihre Angaben."))),
                error?.["status"] === "blocked" && (m("div", { class: "pulse animated" },
                    m("p", { class: "alert alert--danger alert--icon mb3" },
                        m("i", { class: "fas fa-exclamation-triangle" }),
                        `Ihr Account wurde bis {blockedUntil} Uhr gesperrt. Bitte
                                versuchen Sie es dann erneut.`.replace("{blockedUntil}", blockedUntil)))),
                error?.["status"] === "unallowed-subnet" && (m("div", { class: "pulse animated" },
                    m("p", { class: "alert alert--danger alert--icon mb3" },
                        m("i", { class: "fas fa-exclamation-triangle" }),
                        "Um dich anmelden zu k\u00F6nnen, musst du dich in einem Phoenix Netzwerk befinden."))),
                error?.["status"] === "missing-role" && (m("div", { class: "pulse animated" },
                    m("p", { class: "alert alert--warning alert--icon mb3" },
                        m("i", { class: "fas fa-exclamation-triangle" }),
                        "Dir wurde mindestens eine wichtige Rolle nicht gesetzt, ohne die du in Mein Phoenix nicht viel machen kannst. Melde dich bitte bei der IT."))),
                User.online && !error && isGuestUser && (m("div", { class: "bounceIn animated" },
                    m("p", { class: "alert alert--info alert--icon" },
                        m("i", { class: "fas fa-info-circle" }),
                        webtexte["login__mp__kennenlernen__info"]
                            ? m.trust(striptags(webtexte["login__mp__kennenlernen__info"], html.allowed))
                            : "Wir haben Zugangsdaten für Sie generiert. Sie brauchen nur noch auf Anmelden drücken."))),
                m("label", { class: "textfield custom-field" },
                    m("span", { class: `textfield__label ${first.complaint ? "alert--warning" : ""}` }, first.complaint
                        ? "Bitte Ihre Buchungsnr. angeben"
                        : "Buchungs-/Rechnungsnummer"),
                    m("input", { type: "text", name: "first", maxLength: "100", autocomplete: "username", value: first.value(), placeholder: "z.B. 123456", maxlength: first.value().match(/^\d{6}$/) ? 6 : 100, oninput: (e) => first.validate(e.target.value.replace(/\s/g, "")), disabled: noInputPossible ||
                            isGuestUser ||
                            pwdprotected ||
                            twoAuthResponse })),
                m("label", { class: "textfield custom-field" },
                    m("span", { class: `textfield__label ${second.complaint ? "alert--warning" : ""}` }, second.complaint ? "Bitte Ihren Nachnamen angeben" : "Nachname"),
                    m("input", { name: "second", maxLength: "100", autocomplete: "off", value: second.value(), type: isCustomer ? "text" : "password", placeholder: isCustomer ? "z.B. Mustermann" : "", oninput: (e) => second.validate(e.target.value.replace(/\s/g, "")), disabled: noInputPossible ||
                            isGuestUser ||
                            pwdprotected ||
                            twoAuthResponse })),
                pwdprotected && [
                    !!webtexte["login__pw__hint"] && (m("div", { class: "alert alert--info alert--icon" },
                        m("i", { class: "fas fa-info-circle" }),
                        m.trust(striptags(webtexte["login__pw__hint"], html.allowed)))),
                    m("label", { class: "textfield ma0 bounceIn animated custom-field" },
                        m("span", { class: `textfield__label ${pwd.complaint ? "alert--warning" : ""}` }, "Ihr Passwort"),
                        m("input", { name: "password", maxLength: "100", autocomplete: "current-password", value: pwd.value(), type: showpassword ? "text" : "password", oninput: (e) => pwd.validate(e.target.value), disabled: noInputPossible || twoAuthResponse }),
                        m("button", { type: "button", onclick: () => (state.showpassword = !showpassword), class: `pa0 pw-toggle ${showpassword ? "active" : "inactive"}`, title: `Eingabe ${showpassword ? "ausblenden" : "einblenden"}` },
                            m("i", { class: "fas fa-eye" }))),
                    !!webtexte["login__pw__text"] && (m("a", { href: "javascript:", class: "pa0 mb3 mr1", title: "Hilfe aufrufen", onclick: () => (state.showPwHelp = true) },
                        m("small", null, "Welches Passwort?"))),
                    m("a", { class: "pa0 mb3 ml1", title: "neues Passwort setzen", href: `${urls.PASSWORD_PROTECT}/vergessen` },
                        m("small", null, "Passwort vergessen?")),
                ],
                !!twoAuthResponse && (m("p", { class: "alert alert--info alert--icon" },
                    m("i", { class: "fas fa-info-circle" }),
                    "Es wurde ein ",
                    m("strong", null, "Code"),
                    " per",
                    " ",
                    m("strong", null, twoAuthResponse["two-factor-auth-chan"]),
                    " an die Nummer",
                    " ",
                    m("strong", null, twoAuthResponse["two-factor-auth-addr-scrambled"]),
                    " ",
                    "geschickt. Diesen bitte hier eingeben.")),
                !!twoAuthResponse && (m("label", { class: "textfield" },
                    m("span", { class: `textfield__label ${twoFactorCode.complaint ? "alert--warning" : ""}` }, "SMS/E-Mail Code"),
                    m("input", { maxLength: "30", type: "password", autocomplete: "off", name: "two-factor-code", placeholder: "dein Code...", disabled: noInputPossible, value: twoFactorCode.value(), oninput: (e) => twoFactorCode.validate(e.target.value) }))),
                !!webtexte["login__erklaerung"] && (m("div", null, m.trust(striptags(webtexte["login__erklaerung"], html.allowed)))),
                m("div", { class: "flex justify-between items-center" },
                    m("div", null, !attrs.prefilled && first.value().match(/^\d{6}$/) && (m("label", { class: "checkbox ma0" },
                        m("input", { type: "checkbox", name: "login-save", checked: state.saveLogin, onclick: () => (state.saveLogin = !state.saveLogin) }),
                        m("span", { class: "checkbox__label" },
                            m("span", { class: "desktop-only" }, "Eingabe"),
                            " speichern")))),
                    m("div", { class: "flex items-end flex-row-reverse" },
                        m("button", { type: "submit", class: "btn ma0", disabled: noInputPossible, id: isGuestUser ? "gettoknow-login" : "normal-login" },
                            submitting ? (m("i", { class: "fas fa-spinner fa-spin mr2" })) : (m("i", { class: "fas fa-sign-in-alt mr2" })),
                            "Anmelden"),
                        m("button", { type: "button", class: "btn btn--link ma0 mr2 btn", title: "Info anzeigen, wie Sie die ben\u00F6tigten Daten finden", onclick: () => (Context.showHelp = !Context.showHelp) },
                            m("i", { class: "fas fa-question-circle mr1" }),
                            m("span", null, "Hilfe")))),
                state.showPwHelp && !!webtexte["login__pw__text"] && (m(Modal, { title: "Passwort-Hilfe", toggle: () => (state.showPwHelp = false), content: m("div", null, m.trust(striptags(webtexte["login__pw__text"], html.allowed))), footer: m("div", { class: "tr" },
                        m("button", { type: "button", onclick: () => (state.showPwHelp = false) },
                            m("i", { class: "fas fa-times mr2" }),
                            "Schlie\u00DFen")) }))));
        }
        catch (e) {
            logError(e);
            location.href = urls.FE_ERROR;
        }
    },
};
export default View;
